var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7219 15L8.5598 9.83731C6.26343 11.4698 3.09912 11.0705 1.28036 8.91869C-0.538396 6.7669 -0.404849 3.58048 1.58758 1.58839C3.57949 -0.404564 6.76641 -0.53868 8.91874 1.27987C11.0711 3.09843 11.4706 6.26285 9.8379 8.55929L15 13.722L13.7228 14.9991L13.7219 15ZM5.41919 1.80695C3.70635 1.80657 2.22862 3.00883 1.88067 4.68586C1.53272 6.36288 2.41019 8.05374 3.98182 8.73472C5.55345 9.4157 7.38728 8.89964 8.37305 7.49898C9.35881 6.09831 9.22556 4.19802 8.05398 2.94861L8.60045 3.49053L7.98443 2.87636L7.97359 2.86552C7.29776 2.18557 6.3779 1.80437 5.41919 1.80695Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4f323f746b16c03f9e831a3b8c7a2aaa.svg";
export { ForwardRef as ReactComponent };